import React from "react";
import { Button, Divider, makeStyles, Typography } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 220,
    maxWidth: 320,
    padding: "4px 0",
  },
  header: {
    fontWeight: 600,
    marginBottom: 4,
    color: theme.palette.text.primary,
  },
  body: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    marginBottom: 6,
  },
  footer: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginBottom: 6,
  },
  button: {
    textTransform: "none",
    fontWeight: 600,
  },
  urlHint: {
    display: "block",
    marginTop: 4,
    fontSize: "0.7rem",
    color: theme.palette.text.secondary,
    wordBreak: "break-all",
  },
}));

const parseCtaPayload = body => {
  if (!body) return null;
  try {
    const parsed = JSON.parse(body);
    if (parsed && (parsed.type === "cta_url" || parsed.displayText || parsed.url)) {
      return parsed;
    }
  } catch {
    return null;
  }
  return null;
};

const CtaUrlPreview = ({ messageBody }) => {
  const classes = useStyles();
  const payload = parseCtaPayload(messageBody);

  if (!payload) {
    return <Typography variant="body2">{messageBody}</Typography>;
  }

  const handleOpen = () => {
    if (payload.url) {
      window.open(payload.url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className={classes.root}>
      {payload.header ? (
        <Typography className={classes.header} variant="subtitle2">
          {payload.header}
        </Typography>
      ) : null}
      <Typography className={classes.body} variant="body2">
        {payload.body}
      </Typography>
      {payload.footer ? (
        <Typography className={classes.footer} variant="caption">
          {payload.footer}
        </Typography>
      ) : null}
      <Divider />
      <Button
        className={classes.button}
        color="primary"
        fullWidth
        startIcon={<OpenInNewIcon fontSize="small" />}
        onClick={handleOpen}
        disabled={!payload.url}
      >
        {payload.displayText || i18n.t("messagesList.ctaUrl.open")}
      </Button>
      {payload.url ? (
        <span className={classes.urlHint}>{payload.url}</span>
      ) : null}
    </div>
  );
};

export default CtaUrlPreview;
export { parseCtaPayload };
